<template>
    <transition name="modal-fade">
        <div class="modal-backdrop" v-bind:class="className">
            <div class="modal-overlay" @click="back()"></div>
            <div class="modal">
                <article v-if="resource">
                    <header>
                        <figure>
                          <img :src="$iconFolder + 'company.svg'"/>
                        </figure>
                        <div>
                            <span class="breadcrumb">
                                Company <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
                            <h1>{{ resource.name ? resource.name : 'Nouveau' }}</h1>
                        </div>
                        <div class="spacer"></div>
                        <div class="buttons">
                            <button @click="back()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
                            <button @click="submit()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
                        </div>
                    </header>

                    <main>

                        <tabs :options="{ useUrlFragment: false }">
                            <tab name="Information">

                                <form-scopes label='Scopes' v-model="resource"></form-scopes>

                              <fieldset>
                                <h3>Détail</h3>
                                <p class="headline"></p>

                                <form-file label="Logo" v-model="resource.picture_id" :width="200"></form-file>
                                <form-text label="Nom" v-model="resource.name" :required="true"></form-text>
                                <form-text label="No Registre" v-model="resource.registration_number"></form-text>
                                <form-text label="No TVA" v-model="resource.vat_number"></form-text>
                                <form-select label="Geste commercial" multiple="false" v-model="resource.commercial_gesture" :default="resource.commercial_gesture_id" :options="commercialGestures" v-if="commercialGestures"></form-select>
                                <form-select label="Conditions de paiement (par défaut)" multiple="false"
                                             v-model="resource.payment_condition"
                                             :options="$store.getters.scope.payment_conditions"></form-select>
                              </fieldset>

                              <fieldset>
                                <h3>Attributs</h3>
                                <p class="headline"></p>

                                <component-attributes v-model="resource" :locale="locale"></component-attributes>

                              </fieldset>

                            </tab>
                            <tab name="Adresses">

                              <fieldset>
                                <h3>Adresses</h3>
                                <p class="headline"></p>

                                <component-address v-model="resource.addresses"></component-address>

                              </fieldset>

                            </tab>
                          <tab name="Historique commandes" v-if="resource.id">

                            <fieldset>
                              <h3>Flux d'achats</h3>
                              <p class="headline"></p>
                              <timeline v-model="resource.customer_orders_workflow"/>
                            </fieldset>

                            <fieldset>
                              <h3>Détail des commandes passées</h3>
                              <order-person-widget :person_id="resource.id"></order-person-widget>
                            </fieldset>

                          </tab>
                        </tabs>

                    </main>
                </article>
            </div>
        </div>
    </transition>
</template>
<script>

    import CompanyService from './CompanyService.js';
    import Edit from '../../layouts/Edit.vue';

    import ComponentAttributes from "../../components/Attributes.vue";
    import ComponentAddress from "../../components/Address.vue";
    import CommercialGestureService from '../shop/commercial-gesture/CommercialGestureService.js'
    import OrderByPersonWidget from '../shop/order/OrderByPersonWidget.vue'

    export default {
        extends: Edit,
        components:{
            'component-address': ComponentAddress,
            'component-attributes': ComponentAttributes,
            'order-person-widget': OrderByPersonWidget
        },
        data () {
            return {
                resource: {
                    addressable: []
                },
                resourceModal: null,
                commercialGestures: null
            }
        },
        mounted: function(){
            this.resourceModal = this.resource || {};

          CommercialGestureService.all().then(response => {
            this.commercialGestures = response.data
            this.isLoading = false
          })
        },
        methods:{
          beforeUpdate: function (Resource) {

            Resource.commercial_gesture_id = Resource.commercial_gesture && Resource.commercial_gesture.id ? Resource.commercial_gesture.id : null
            Resource.payment_condition_id = Resource.payment_condition && Resource.payment_condition.id ? Resource.payment_condition.id : null

            return true;
          },
            resourceLoaded: function(){
                this.localesLoaded = true;
                this.resource.addresses = this.resource.addresses || [];
                this.initialize()
            },
            getResource: function(){
                return CompanyService
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/company/Edit.vue